import './style.scss';
import React, { useState, useEffect, useCallback } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter, useParams } from 'react-router-dom';

import { getProfileInfo } from '../../../services/utils';

import { updateConfigHeaderFooter, updateConfigCampaign, updateApiReplication } from '../../../actions';
import { Preloader } from '../../atoms';
import { getEvaluationQuestionnaires } from '../../../services/api';
import { EvaluationType } from 'types/evaluation';
import { EvaluationKnowledge, EvaluationFormGeneric } from 'pctComponents/organisms';

import { ContextEvaluationKnowledge } from '../../../pctContexts/contextEvaluationKnowledge';

import useMediaQuery from '../../../pctHooks/useMediaQuery';

import useNotificationCampaigns from '../../../pctHooks/useNotificationCampaigns';

type evaluationsType = {
    idEnrollment?: string;
    idEvaluation?: string;
    idQuestionnaire?: string;
};

const Evaluations = (props) => {
    const isMobile = useMediaQuery('md');
    const [fetchData, setFetchData] = useState<any>(null);
    const [errorFetchData, setErrorFetchData] = useState(false);
    const userProfile = getProfileInfo();
    const { updateConfigHeaderFooter } = props;
    const { idEnrollment, idEvaluation, idQuestionnaire } = useParams<evaluationsType>();

    const { verifyNotificationCampaigns } = useNotificationCampaigns();

    useEffect(() => {
        if (fetchData) {
            const { evaluation } = fetchData;
            if (isMobile && evaluation.evaluationType !== EvaluationType.REACTION) {
                document.body.classList.add('bodyOverflowHidden');
            } else {
                document.body.classList.remove('bodyOverflowHidden');
            }
        }

        return () => {
            document.body.classList.remove('bodyOverflowHidden');
        };
    }, [isMobile, fetchData]);

    const retrieveEvaluationData = useCallback(() => {
        getEvaluationQuestionnaires({
            idUser: userProfile.idUser,
            idEnrollment: idEnrollment,
            idEvaluation: idEvaluation,
            idQuestionnaire: idQuestionnaire,
        })
            .then((res) => {
                setFetchData(res.data);
            })
            .catch((error) => {
                setErrorFetchData(true);
            });
    }, [userProfile.idUser, idEnrollment, idEvaluation, idQuestionnaire]);

    useEffect(() => {
        if (fetchData) {
            callUpdateConfigHeaderFooter();
        } else {
            retrieveEvaluationData();
            const contentNavigation = { idEnrollment: idEnrollment }; // Verificar status Notification Campaigns Inicial
            verifyNotificationCampaigns(contentNavigation, props);
        }
    }, [idEnrollment, idEvaluation, idQuestionnaire, fetchData]);

    const callUpdateConfigHeaderFooter = () => {
        ///Atualizar Campaigins
        updateConfigHeaderFooter({
            footerStyle: 'hide',
            prevNavStyle: 'closeShow',
            contentNavigation: fetchData,
            backCloseText: 'FECHAR AVALIAÇÃO',
        });
        ///Atualizar Campaigins
    };

    const finishEvent = () => {
        retrieveEvaluationData();

        /// Verifica ao completar o Content e se o NodeErrolment foi Completado e Notificação Campaingns
        const contentNavigation = { idEnrollment: idEnrollment }; // Verificar status Notification Campaigns Inicial
        verifyNotificationCampaigns(contentNavigation, props);
    };

    const currentEvaluationType = () => {
        const { evaluation } = fetchData;
        switch (evaluation.evaluationType) {
            case 'REACTION':
                // AVALIAÇÃO DE REAÇÃO.
                return (
                    <div className={`pctPage pctEvaluation`}>
                        <EvaluationFormGeneric
                            fetchData={fetchData}
                            idEnrollment={idEnrollment}
                            idEvaluation={idEvaluation}
                            idQuestionnaire={idQuestionnaire}
                            finishEvent={finishEvent}
                        />
                    </div>
                );

            case 'KNOWLEDGE':
                // AVALIAÇÃO DE CONHECIMENTO.
                return (
                    <ContextEvaluationKnowledge>
                        <div className={`pctPage pctEvaluation`}>
                            <EvaluationKnowledge
                                fetchData={fetchData}
                                idEnrollment={idEnrollment}
                                idEvaluation={idEvaluation}
                                idQuestionnaire={idQuestionnaire}
                                idNodeEnrollment={fetchData.idNodeEnrollment}
                                finishEvent={finishEvent}
                            />
                        </div>
                    </ContextEvaluationKnowledge>
                );

            case 'STUDENT_IMPACT':
                // AVALIAÇÃO DE IMPACTO DO ALUNO.
                return (
                    <div className={`pctPage pctEvaluation`}>
                        <EvaluationFormGeneric
                            fetchData={fetchData}
                            idEnrollment={idEnrollment}
                            idEvaluation={idEvaluation}
                            idQuestionnaire={idQuestionnaire}
                            finishEvent={finishEvent}
                            customTitle="Avaliação de Impacto"
                        />
                    </div>
                );

            default:
                return <p>TIPO DE AVALIAÇÃO NÃO ENCONTRADA.</p>;
        }
    };

    if (errorFetchData) return <p>There is an error.</p>;
    if (!fetchData) return <Preloader />;

    return currentEvaluationType();
};

const mapDispatchToProps = (dispatch) => ({
    updateConfigHeaderFooter: (item) => dispatch(updateConfigHeaderFooter(item)),
    updateConfigCampaign: (item) => dispatch(updateConfigCampaign(item)),
    updateApiReplication: (item) => dispatch(updateApiReplication(item)),
});

const mapStateToProps = (store) => ({
    apiReplication: store.apiReplicationState,
    configHeaderFooter: store.configHeaderFooterState.configHeaderFooter,
    configCampaign: store.configCampaignState.configCampaign,
});

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Evaluations);
